module.exports = __webpack_public_path__ + "img/img-d14439be.9887a6df.png";